import React from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import { Layout } from "antd";
import { Routes, Route } from 'react-router-dom';
import HeaderNav from "../../Components/Header/Header";
import ApproveDeckleJobCardsData from "./approveDeckleJobCards/approveDeckleJobCards";
import ApproveDeckleJobCardDetailData from "./approveDeckleJobCards/approveJobCardDetails";
const { Content } = Layout;

const listItems = [
    {
        icon: 'file-setting',
        label: 'Order Records',
        link: 'order-records'
    },
    {
        icon: 'group-user',
        label: 'Job Cards',
        link: 'approve-job-cards'
    },
];

const ApproveDeckleData = props => {
    return (
        <Layout>
            <HeaderNav />
            <Layout>
                <Sidebar headerName="CONFIGURATION MASTER" listItems={listItems} />
                <Layout>
                    <Content>
                        <Routes>
                        <Route path="approve-job-cards" element={<ApproveDeckleJobCardsData/>}/>
                        <Route path="approve-deckle-job-cards" element={<ApproveDeckleJobCardDetailData/>}/>
                        </Routes>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
}

export default ApproveDeckleData;